// Ids of tracked mutations whose request is on the wire in THIS tab right
// now. The tracker link writes the entry to storage before sending it and
// removes it only when the response arrives, so storage alone cannot tell a
// queued entry from one already being sent. In-memory on purpose: a request
// from another tab or a previous page load is not this tab's to wait for.
const inFlight = new Set();
export const markInFlight = (id) => {
    inFlight.add(id);
};
export const clearInFlight = (id) => {
    inFlight.delete(id);
};
export const isInFlight = (id) => inFlight.has(id);
